<template>
  <div class="content">
    <div class="content-item">
      <div class="box-head">
        <div class="box-title">
          <div>订单类型</div>
        </div>
      </div>
      <div class="box-body">
        <div class="com-container">
          <div class="com-chart" ref="order_type"></div>
        </div>
      </div>
    </div>
    <div class="content-item">
      <div class="box-head">
        <div
          class="box-title"
          style="justify-content: space-between; padding: 10px 10px"
        >
          <div>累计撮合订单金额</div>
          <section class="box-title-allcount">
            <h4>65663</h4><i>万</i>
            <!-- <h4>{{ amountTotal }}</h4><i>万</i> -->
            <article>
              <!-- <i>+{{ amountLastMonth }}</i> -->
              <i>+13695</i>
              <em>上月</em>
            </article>
          </section>
        </div>
      </div>
      <ul class="product-top">
        <li>
          <div>产品名称</div>
          <div>采购数量</div>
          <div>订单价值(元)</div>
        </li>
      </ul>
      <div v-if="demandLinkList && demandLinkList.length > 0">
        <vue-seamless-scroll
          :data="demandLinkList"
          class="seamless-warp"
          :class-option="classOption"
        >
          <ul class="product-top">
            <li v-for="v in demandLinkList" :key="v.id">
              <div>{{ v.orderName }}</div>
              <div>{{ v.purchaseQuantity }}</div>
              <div>{{ v.orderValue }}</div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      chartInstance: null,
      allData: null,
      demandLinkList: [],
      amountLastMonth: 0,
      amountTotal: 0,
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.4,
        limitMoveNum: 8,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000,
      };
    },
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    // 在页面加载完成的时候, 主动进行屏幕的适配
    this.screenAdapter();
  },
  destroyed() {
    // 在组件销毁的时候, 需要将监听器取消掉
    window.removeEventListener("resize", this.screenAdapter);
  },
  methods: {
    initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.order_type, "chalk");
      const initOption = {
        legend: {
          bottom: "3%",
          icon: "rect",
          textStyle: {
            color: "#fff",
            fontSize: 13,
          },
        },
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              // borderColor: '#fff',
              // borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
          },
        ],
      };
      this.chartInstance.setOption(initOption);
    },
    async getData() {
      const res = await axios.get(this.$api.orderType);
      this.allData = res.data.data;
      this.updateChart();
      const res2 = await axios.get(this.$api.orderDetail);
      this.amountLastMonth = res2.data.data.amountLastMonth;
      this.amountTotal = res2.data.data.amountTotal;
      this.demandLinkList = res2.data.data.orderAmount;
    },
    updateChart() {
      let seriesData = this.allData.map((item) => {
        return {
          name: item.name,
          value: item.value,
        };
      });
      const legendData = this.allData.map((item) => {
        return {
          name: item.name,
        };
      });
      const dataOption = {
        color: [
          "#617FEB",
          "#59AED3",
          "#B55AFF",
          "#EECC32",
          "#27BF99",
          "#EEDD78",
          "#59AED3",
        ],
        legend: {
          data: legendData,
        },
        series: [
          {
            data: seriesData,
          },
        ],
      };
      this.chartInstance.setOption(dataOption);
    },
    screenAdapter() {
      const titleFontSize = (this.$refs.order_type.offsetWidth / 100) * 3.6;
      this.titleFontSize = titleFontSize;
      const adapterOption = {
        title: {
          textStyle: {
            fontSize: this.titleFontSize,
          },
        },
        legend: {
          itemWidth: this.titleFontSize / 2,
          itemHeight: this.titleFontSize / 2,
          itemGap: this.titleFontSize / 2,
          textStyle: {
            // fontSize: this.titleFontSize / 1.5,
            fontSize: 13,
          },
        },
        series: [
          {
            radius: this.titleFontSize * 4.5,
            radius: ["40%", "70%"],
          },
        ],
      };
      this.chartInstance.setOption(adapterOption);
      // 手动的调用图表对象的resize 才能产生效果
      this.chartInstance.resize();
    },

    toLeft() {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.allData.length - 1;
      }
      this.updateChart();
    },
    toRight() {
      this.currentIndex++;
      if (this.currentIndex > this.allData.length - 1) {
        this.currentIndex = 0;
      }
      this.updateChart();
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  justify-content: space-between;
  height: 100%;
  .content-item {
    width: 48%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: rgba(83, 98, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.26);
    border-radius: 12px;
    .box-head {
      position: relative;
      .box-title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 10px 5px 10px;
        div {
          width: 11rem;
          height: 2.5rem;
          border: 2px solid #4668ec;
          box-shadow: 0 0 8px 0 rgba(128, 173, 255, 0.5),
            inset 0 0 20px 0 rgba(26, 242, 255, 0.1);
          border-radius: 8px;
          font-size: 1.1rem;
          font-weight: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          font-style: italic;
        }
        span {
          color: #0087f9;
          font-size: 0.875rem;
          align-self: end;
          margin-left: 0.625rem;
        }
      }
    }
    .box-body {
      flex: 1;
      background-color: rgba(7, 65, 122, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        background: url("/static/img/tk.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        padding: 0.3125rem 1.25rem;
        font-weight: bold;
        margin-top: 1.25rem;
      }
      .time {
        background: url("/static/img/zxsb@3x.png");
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        margin-top: 1.25rem;
        height: 120px;
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .time-1 {
          font-weight: bold;
          color: #00edff;
          font-size: 1.4rem;
        }
        .time-2 {
          font-size: 0.75rem;
          color: #00edff;
        }
      }
      .act {
        margin-top: 1.25rem;
        height: 120px;
        width: 120px;
      }
    }
  }
}

.box-line-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}
.box-line-2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}
.box-line-3 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}
.box-line-4 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}
.arr-left {
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: white;
}

.arr-right {
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: white;
}

.cat-name {
  position: absolute;
  left: 80%;
  bottom: 20px;
  color: white;
}

.product-top {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    display: flex;
    justify-content: space-between;
    color: #ffffff;
    font-size: 14px;
    background-color: rgba(10, 209, 201, 0.1);
    padding: 8px 0;
    div {
      width: 33%;
      flex-shrink: 0;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.seamless-warp {
  width: 100%;
  margin-top: 10px;
  height: 100%;
  overflow: hidden;
}

.box-title-allcount {
  display: flex;
  align-items: center;
  color: #ffcf00;
  background-color: rgba(0,0,0,0.2);
  padding: 8px 15px;
  h4 {
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: 1.33rem;
  }
  article {
    margin-left: .8rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
